import React from 'react';
const defaultValue = {
    gba: undefined,
    clearGbaInstance: (() => { }),
    setFpsCallback: (() => { }),
    canvasRef: undefined,
    play: (() => { }),
    saveState: (() => { }),
    frozenAddresses: {},
    addFreezeAddress: (() => { }),
    removeFreezeAddress: (() => { }),
};
const GbaContext = React.createContext(defaultValue);
export default GbaContext;
